import Cookies from 'js-cookie'

const LangKey = 'Lang'

export function getLang() {
  return Cookies.get(LangKey)
}

export function setLang(lang) {
  return Cookies.set(LangKey, lang)
}

export function removeLang() {
  return Cookies.remove(LangKey)
}



// WEBPACK FOOTER //
// ./src/utils/index.js